<div class="w-full">
    <span class="flex justify-between" *transloco="let t; read 'input.file'">
      <span class="flex">
        <label class="block mb-2 {{required ? requiredClasses : ''}}" *ngIf="label"
               [ngClass]="{ disabled: isDisabled }">{{label}}</label>
      <psc-info-icon [iconColorClass]="infoIconColorClass" [infoText]="infoText"
                     [sizeInPx]="infoIconSize"></psc-info-icon>
      </span>
      <div class="flex text-gray-400 items-baseline">
        <span class="text-[14px]"
              *ngIf="formControl.pvscAdditionalData.fileType">
        {{t('file_type', { fileType: formControl.pvscAdditionalData.fileType })}}.
      </span>
      <span class="ml-1 pl-1 text-[14px]"
            *ngIf="formControl.pvscAdditionalData.fileSizeInMB">
        {{t('file_size', { fileSizeInMB: formControl.pvscAdditionalData.fileSizeInMB })}}.
      </span>
      </div>
    </span>
  <input
    (change)="onModelChange($any($event.target).files)"
    [multiple]="multiple"
    [disabled]="isDisabled"
    [accept]="formControl.pvscAdditionalData.fileType ? mapToType(formControl.pvscAdditionalData.fileType) : ''"
    class="{{inputNoPaddingClasses}} file:cursor-pointer file:mr-4 file:border-0
      file:font-semibold
      file:bg-sun-yellow file:text-white
      hover:file:bg-roof-orange file:p-[16px]"
    type="file">

  <psc-input-error
    [control]="formControl"></psc-input-error>
</div>
